(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabObjectStates', TabObjectStates);

    TabObjectStates.$inject = ['$resource'];

    function TabObjectStates ($resource) {
        var resourceUrl =  'api/tab-object-states/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
